import { IEvent, ISpineData, SpineBase } from "@quest/base-core";
import { ingenuity } from "@quest/base-core/dist"
import { BaseViewGame } from "../BaseViewGame";

export class StackSymbolFeatureViewBG extends BaseViewGame {
    /** Resize */
    protected resize(evt: IEvent): void {
        if (!ingenuity.deviceEnv.isDesktop) {
            if (this.CurrentOrientation !== ingenuity.deviceEnv.getOrientation()) {
                this.CurrentOrientation = ingenuity.deviceEnv.getOrientation();
                this.updateOrientation();
            }
        }
    }

    /**
     * method getSpineJsonAndCloneSym: clone spine animation
     */
    public getSpineJsonAndCloneSym(): SpineBase {
        let stackSpineJsonObj: ISpineData = this.json["hp_chara"];
        stackSpineJsonObj.type = "spine";
        let stackSpineCloneAnim: SpineBase = this.createSpine(stackSpineJsonObj);
        stackSpineCloneAnim.visible = false;
        return stackSpineCloneAnim;
    }
    /**
      * to clone spine
      */
    public getStackTransitionClone(): SpineBase {
        let stackSpineJsonObj: ISpineData = this.json["stack_effect"];
        stackSpineJsonObj.type = "spine";
        let stackSpineCloneAnim: SpineBase = this.createSpine(stackSpineJsonObj);
        stackSpineCloneAnim.visible = false;
        return stackSpineCloneAnim;
    }
}